var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoodMenu = function SvgFoodMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.333h2v13.334H1V1.333ZM7 5h5v2H7V5Zm0 3h5v2H7V8Z",
    fill: "#30384C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.667V2.333h8.667c.183 0 .333.15.333.334v10.666c0 .183-.15.334-.333.334H5Z",
    stroke: "#30384C",
    strokeWidth: 2
  })));
};
export default SvgFoodMenu;